import { SideNavInterface } from '../../interfaces/side-nav.type';

export const ROUTES_STORE: SideNavInterface[] = [
  {
    path: '/home',
    title: 'Home',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'home',
    submenu: []
  },
  {
    path: '/details',
    title: 'Store Setup',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'appstore',
    submenu: [
    ]
  },
  {
    path: '/stocks',
    title: 'Stocks',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'slack',
    submenu: [
    ]
  },
  {
    path: '/orders',
    title: 'Orders',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'schedule',
    submenu: [
    ]
  },{
    path: '/marketing',
    title: 'Marketing',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'cloud',
    submenu: [
    ]
  },
  {
    path: '/accounts',
    title: 'Accounts',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'user',
    submenu: [
    ]
  },
  {
    path: '/sales',
    title: 'Sales',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'bar-chart',
    submenu: [
    ]
  },
  {
    path: '/analytics',
    title: 'Analytics',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'bar-chart',
    submenu: [
    ]
  },{
    path: '/settings',
    title: 'Settings',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'setting',
    submenu: [
    ]
  }
]
